import type { TOC } from '@ember/component/template-only';
import { or } from 'ember-truth-helpers';
import SettingsCentralMappingDropdownsDropdownBarBased from 'lumen/components/settings/central-mapping/dropdowns/dropdown-bar-based';
import { TRIGGER_CENTRAL_MAPPING_VARIANTS } from 'lumen/components/settings/central-mapping/dropdowns/triggers/trigger-central-mapping';
import type { BarBased } from 'lumen/models/central-mapping/mapping-entry-market-segment';

interface MarketSettingsCentralMappingTablesCellsTdBarBasedSignature {
  Args: {
    column: {
      isReadOnly?: boolean;
    };
    row: {
      autoBarBased: BarBased;
      barBased: BarBased;
      isMixedBarBased: boolean;
      setBarBased: (value: BarBased) => void;
      userBarBased: BarBased;
    };
    rowMeta: {
      isSelected: boolean;
    };
  };
}

const MarketSettingsCentralMappingTablesCellsTdBarBased: TOC<MarketSettingsCentralMappingTablesCellsTdBarBasedSignature> =
  <template>
    <div data-test-id="table-central-mapping-td-bar-based">
      <SettingsCentralMappingDropdownsDropdownBarBased
        @autoBarBased={{@row.autoBarBased}}
        @barBased={{@row.barBased}}
        @isMixed={{@row.isMixedBarBased}}
        @isReadOnly={{or @column.isReadOnly @rowMeta.isSelected}}
        @isSelected={{@rowMeta.isSelected}}
        @setBarBased={{@row.setBarBased}}
        @userBarBased={{@row.userBarBased}}
        @variant={{TRIGGER_CENTRAL_MAPPING_VARIANTS.SUBDUED}}
      />
    </div>
  </template>;

export default MarketSettingsCentralMappingTablesCellsTdBarBased;
